module.exports = "new-file";


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file4/dir/new-file.js
 ** module id = 18
 ** module chunks = 0
 **/